import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonTab from 'Utils/Helpers/ButtonTab';
import { Outlet } from "react-router-dom";
import * as icons from 'react-bootstrap-icons';
import { useNavigate } from "react-router-dom";
import { SettingTabs } from 'Utils/Constants/SettingTabs';

export default function SettingsIndex() {
    const navigate = useNavigate();
    const [menu, setMenu] = useState([]);
    const [loading, setLoading] = useState(true);
    const { current } = useSelector((state) => ({
        current: state.staff.current,
    }));
    useEffect(() => {
        if(current && current.length !== 0 && current[4][0]) {
            let _new = []
            SettingTabs.map(item => {
                _new.push({
                    title: item.title,
                    icon: item.icon,
                    index: item.index,
                    active: item.active ? item.acin.length ? current[item.acin[0]][item.acin[1]] ? true : false : false : false,
                    link: item.link,
                    acin: item.acin,
                })
            })
            setMenu(_new);
        } else {
            setMenu([]);
        }
    }, [current])
    useEffect(() => {
        if(current && current.length !== 0 && current[4][0]) {
            if(!window.location.pathname.split('/')[3]) {
                rawNavigate()
            } else {
                if(!current[4][1] && window.location.pathname.includes("/dashboard/setting/times")) rawNavigate();
                else if(!current[4][2] && window.location.pathname.includes("/dashboard/setting/doctors")) rawNavigate();
                else if(!current[4][3] && window.location.pathname.includes("/dashboard/setting/types")) rawNavigate();
                else if(!current[4][4] && window.location.pathname.includes("/dashboard/setting/statuses")) rawNavigate();
                else if(!current[4][5] && window.location.pathname.includes("/dashboard/setting/message")) rawNavigate();
                else if(!current[4][6] && window.location.pathname.includes("/dashboard/setting/bank")) rawNavigate();
                else setLoading(false);
            }
        }
    },[current, window.location.pathname, menu])
    const rawNavigate = () => {
        if(current[4][1]) navigate('/dashboard/setting/times');
        else if(current[4][2]) navigate('/dashboard/setting/doctors');
        else if(current[4][3]) navigate('/dashboard/setting/types');
        else if(current[4][4]) navigate('/dashboard/setting/statuses');
        else if(current[4][5]) navigate('/dashboard/setting/message');
        else if(current[4][6]) navigate('/dashboard/setting/bank');
        else {
            navigate('/dashboard/setting');
            setMenu([])
        }
        setLoading(false);
    }
    return (
        <div className="settings-content">
            <div className='settings-head'>
                {
                    !loading
                    ? (menu && menu.length !== 0) 
                    ? menu.filter(item => item.active !== false).map(items => {
                        return (
                            <ButtonTab
                                key={items.index}
                                title={items.title}
                                icon={items.icon}
                                active={window.location.pathname.includes(items.link)}
                                onClick={() => navigate(items.link)}
                                index={items.index}
                            />
                        )
                    })
                    : <small className='text-danger'>
                        {"خطایی در بارگزاری فرم تنظیمات پیش آمده است"}
                    </small>
                    : <small>
                        {"لطفا کمی صبر کنید"}
                    </small>
                }
            </div>
            <div className='settings-body' >
                <Outlet/>
            </div>
        </div>

    );
}